import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BillingCommsService {

  private currentAccountId; // stores the accountId of to whom user needs to assign an order.
  private returnToOrigin;

  constructor() { }

  setCurrentAccountIdToAssignOrder(accountId: string) {
    this.currentAccountId = accountId;
  }

  getAccountIdOfCurrentAccount() {
    return this.currentAccountId;
  }

  setReturnToOrigin(origin: string) {
    this.returnToOrigin = origin;
  }

  getReturnToOrigin() {
    return this.returnToOrigin;
  }

  getiFrameQueryParams()
  {
    let params = undefined;
    if ( this.currentAccountId )
    {
      params = "accountid=" + this.currentAccountId;
    }
    if ( this.returnToOrigin )
    {
      if ( params )
        params = params + "&return=" + this.returnToOrigin;
      else
        params =  "return=" + this.returnToOrigin;
    }
    return params;
  }
}
